import { Request } from "@/services/survey-response/surveyRespondeService"

export class ExcelGeneratorService {

    async downloadExcelFile(): Promise<boolean | undefined> {
        const slug = `excel_generator/`
        return Request.download(slug, "Error getting excel file")
    }
}